function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["className", "disabled", "hidden", "input", "meta", "renderPrefix", "renderSuffix", "style"];
var _templateObject, _templateObject2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import styled from 'styled-components';
import { get } from 'lodash';
import FlexContainer from '../FlexContainer';
import Cushion from '../Cushion';
import Typography from '../Typography';
import style from './style';
var InputContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: ", ";\n  box-shadow: rgba(6, 67, 95, 0.3) 0px 1px 1px, rgba(0, 0, 0, 0.1) 0px 2px 3px;\n  box-sizing: border-box;\n  border-color: ", "\n  border-radius: 3px;\n  border-style: solid;\n  border-width: 1px;\n  color: ", ";\n  font-size: 14px;\n  height: 40px;\n  line-height: 1.3;\n  position: relative;\n  width: 100%;\n\n  ", "\n  ", "\n"])), function (props) {
  return props.disabled ? '#F3F3F3' : '#FFF';
}, function (props) {
  return props.error ? '#E26868;' : '#f9f9f9';
}, function (props) {
  return props.disabled ? '#E26868' : '#333';
}, function (props) {
  return props.hidden ? 'display: none;' : '';
}, function (props) {
  return props.disabled ? 'cursor: not-allowed;' : '';
});
var StyledInput = styled.input(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border: none;\n  background: transparent;\n  box-sizing: border-box;\n  color: inherit;\n  cursor: inherit;\n  flex-grow: 1;\n  font-size: inherit;\n  height: inherit;\n  line-height: inherit;\n  outline: 0;\n  position: relative;\n  padding: 0 12px;\n  z-index: 1;\n\n  ::-webkit-input-placeholder {\n    /* Chrome/Opera/Safari */\n    color: #b2b2b2;\n  }\n  ::-moz-placeholder {\n    /* Firefox 19+ */\n    color: #b2b2b2;\n  }\n  :-ms-input-placeholder {\n    /* IE 10+ */\n    color: #b2b2b2;\n  }\n  :-moz-placeholder {\n    /* Firefox 18- */\n    color: #b2b2b2;\n  }\n\n  &:focus + .prui-input-focus > .prui-input-focus__circle {\n    padding-bottom: 110% !important;\n    width: 110% !important;\n    left: 0 !important;\n  }\n"])));
var Input = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var className = props.className,
    disabled = props.disabled,
    hidden = props.hidden,
    _props$input = props.input,
    input = _props$input === void 0 ? {} : _props$input,
    _props$meta = props.meta,
    _props$meta$touched = _props$meta.touched,
    touched = _props$meta$touched === void 0 ? false : _props$meta$touched,
    _props$meta$error = _props$meta.error,
    error = _props$meta$error === void 0 ? false : _props$meta$error,
    renderPrefix = props.renderPrefix,
    renderSuffix = props.renderSuffix,
    customStyle = props.style,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputContainer, {
    className: className,
    style: customStyle,
    disabled: disabled,
    hidden: hidden,
    error: touched && error
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: '100%',
      borderRadius: '3px 0 0 3px'
    }
  }, /*#__PURE__*/React.createElement(FlexContainer, {
    style: {
      height: 'inherit'
    }
  }, renderPrefix && /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      zIndex: 1,
      height: 'inherit',
      borderRadius: '3px 0 0 3px'
    }
  }, renderPrefix()), /*#__PURE__*/React.createElement(StyledInput, _extends({}, otherProps, input, {
    key: "prui-input__input",
    ref: ref,
    hidden: hidden,
    disabled: disabled,
    "data-hj-whitelist": true,
    style: _objectSpread(_objectSpread({}, style.input), get(input, 'style', {}))
  })), renderSuffix && /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      zIndex: 1,
      height: 'inherit',
      borderRadius: '0 3px 3px 0'
    }
  }, renderSuffix()), /*#__PURE__*/React.createElement("span", {
    className: "prui-input-focus",
    style: style.focus
  }, /*#__PURE__*/React.createElement("span", {
    className: "prui-input-focus__circle",
    style: style.circle
  }, /*#__PURE__*/React.createElement("span", {
    className: "prui-input-focus__circle-inner",
    style: style.circleInner
  }, /*#__PURE__*/React.createElement("span", {
    style: style.circleInnerBefore
  }))))))), touched && error && /*#__PURE__*/React.createElement(Cushion, {
    top: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    component: "label",
    preset: "description",
    color: "#E26868"
  }, error)));
});
Input.defaultProps = {
  className: null,
  renderPrefix: null,
  renderSuffix: null,
  meta: {},
  style: {},
  disabled: false,
  hidden: false
};
export default Input;